/* Kailar Neubau D · „Cookie-Einstellungen“ (Fußzeile, Händler-Fußzeile: [data-kd-cookie-open]).
   Der Shop nutzt Shopifys eigenes Cookie-Banner; der Link öffnet dessen Einstellungen (window.privacyBanner).
   Gibt es das Banner hier nicht (z. B. Region ohne Einwilligungspflicht), führt der Link zur Datenschutzerklärung. */
document.addEventListener('click', (e) => {
  const link = e.target.closest('[data-kd-cookie-open], a[href="#cookies"]');
  if (!link) return;
  e.preventDefault();
  const pb = window.privacyBanner;
  if (pb && typeof pb.showPreferences === 'function') {
    pb.showPreferences();
    return;
  }
  window.location.href = '/policies/privacy-policy';
});
